import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import Theme from './theme';
const ns = "PromoPuma";;
process.env.ns = ns;

window[ns] = {};

let container = document.getElementById(ns);

if (!container) {
  container = document.createElement('div');
}

window[ns].widget = container;

ReactDOM.render(
  <React.StrictMode>
    <Theme>
      <App />
    </Theme>
  </React.StrictMode>,
  container
);
